import React, { Fragment, useEffect, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';

import PlayerCard from '../../molecules/player-card/PlayerCard';
import Category, { CategoryType } from '../../atoms/player/category/Category';
import VideoInfoStatus, { VideoInfoStatusType } from '../../atoms/player/video-info-status/VideoInfoStatus';
import ElapsedTime from '../../atoms/player/elapsed-time/ElapsedTime';
import TypographyElements from '../../foundation/typography/typography-element/typography-elements';
import { IconStatus } from '../../../typings/design-tokens';
import { BREAKPOINTS } from '../../../utils/breakpoints';
import styles from '../../../utils/styles';
import TypograpyBodyComponent from '../../foundation/typography/typography-body/typography-body';
import { formatDuration } from '../../../utils/times';
import './Card.scss';

export interface ICard {
  assetId: number;
  duration: string;
  videoStill: string;
  altImage?: string;
  channel: string;
  subChannel: string;
  subSubChannel: string;
  title: string;
  modifyDate: string;
  isMenuOpen?: boolean;
  accessRequired?: boolean;
  navFilterallVisibility?: boolean;
  appType?: string;
}

const Card: React.FC<ICard> = ({
  assetId,
  duration = '0',
  videoStill,
  altImage,
  channel,
  subChannel,
  subSubChannel,
  title,
  modifyDate,
  accessRequired,
  isMenuOpen,
  navFilterallVisibility,
  appType,
}) => {
  const buttonState = appType ? (appType as IconStatus) : 'normal';
  const media = `(min-width: ${BREAKPOINTS.DESKTOP}px)`;
  const isDesktop = useMediaQuery(media);
  const [categoryType, setCategoryType] = useState<CategoryType>('category');
  const [videoStatusType, setVideoStatusType] = useState<VideoInfoStatusType>('not-playing');
  const [playButtonState, setPlayButtonState] = useState<IconStatus>(buttonState);
  const [isHiddenVideoInfoStatus, setIsHiddenVideoInfoStatus] = useState<boolean>(true);
  const [videoDuration, setVideoDuration] = useState<string>(duration);
  useEffect(() => {
    setPlayButtonState(accessRequired ? 'disabled' : buttonState);
    setIsHiddenVideoInfoStatus(!accessRequired);
    setVideoStatusType('accessRequired');
  }, [accessRequired]);

  useEffect(() => {
    if (appType) {
      setPlayButtonState(appType as IconStatus);
    }
  }, [appType]);

  useEffect(() => {
    setVideoDuration(formatDuration(duration));
  }, [duration]);
  return (
    <div className={styles('card', isMenuOpen && 'card--row')}>
      {
        <PlayerCard
          assetId={assetId}
          duration={videoDuration}
          videoStill={videoStill}
          altImage={altImage}
          playButtonState={playButtonState}
          onSetCategoryType={(type: CategoryType) => setCategoryType(type)}
          onSetVideoStatusType={(videoStatusType: VideoInfoStatusType) => setVideoStatusType(videoStatusType)}
          onSetIsHiddenVideoInfoStatus={(isHidden: boolean) => setIsHiddenVideoInfoStatus(isHidden)}
          title={title}
          isDesktop={isDesktop}
          navFilterallVisibility={navFilterallVisibility}
        />
      }

      <div className={styles('card__bottom')}>
        <div className={styles('types')}>
          <Category text={subSubChannel || subChannel || channel} type={categoryType} />
          <VideoInfoStatus type={videoStatusType} isHidden={isHiddenVideoInfoStatus} />
        </div>

        <TypograpyBodyComponent text={title} typographyClass="ty-body-large" className={[styles('title')]} />

        <div className={styles('timing')}>
          {isDesktop && (
            <Fragment>
              <TypographyElements text={videoDuration} typographyClass="ty-elements-medium--uppercase" />
              <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </Fragment>
          )}
          <ElapsedTime modifyDate={modifyDate} />
        </div>
      </div>
    </div>
  );
};

export default Card;
